import classes from './TwoUpContent.module.css.mjs';

const imagesAspectRatio = {
  "50-50": {
    landscape: ["4:3", "4:3"],
    portrait: ["3:4", "3:4"]
  },
  "60-40": {
    landscape: ["4:3", "1:1"],
    portrait: ["4:3", "1:1"]
  },
  "40-60": { landscape: ["1:1", "4:3"], portrait: ["1:1", "4:3"] }
};
const twoUpContentCardsWrapperClassName = {
  "50-50": classes.twoUpContentCardsContainer50,
  "60-40": classes.twoUpContentCardsContainer60,
  "40-60": classes.twoUpContentCardsContainer40
};

export { imagesAspectRatio, twoUpContentCardsWrapperClassName };
